export const brandRoles = ['brand_owner'] as const;
export const enterpriseRoles = ['enterprise_owner'] as const;
export const merchantRoles = ['merchant_owner'] as const;
export const venueGroupRoles = ['venue_group_owner'] as const;
export const venueRoles = [
  'venue_finance_manager',
  'venue_manager',
  'venue_manager_lite',
  'venue_worker',
  'restricted_menu_editor',
] as const;
